import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=f1977aaa&scoped=true&"
import script from "./DocumentViewer.vue?vue&type=script&lang=js&"
export * from "./DocumentViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1977aaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1977aaa')) {
      api.createRecord('f1977aaa', component.options)
    } else {
      api.reload('f1977aaa', component.options)
    }
    module.hot.accept("./DocumentViewer.vue?vue&type=template&id=f1977aaa&scoped=true&", function () {
      api.rerender('f1977aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/attachments/DocumentViewer.vue"
export default component.exports